import React, { useContext } from "react";
import { ConditionalLink } from "../common/ConditionalLink";
import { CodesToColorMapFunc } from "../../CodesToColorMap";
import { DiseaseGroupContext } from "../../contexts/diseaseGroupContext";
import { getIconForCode } from "../../services/summaryReportsService";
import { isValid, format } from "date-fns";
import { ArrowRight } from "../common/IconsV2";
import { SlUser } from "react-icons/sl";

export const TodoItem = ({
	id,
	code,
	locked,
	title,
	action,
	actionLabel,
	dueDate,
	numQuestionnaires,
	questionnaires,
	responseHistoryExists,
	lastSubmissionDate,
}) => {
	const { theme } = useContext(DiseaseGroupContext);

	const formattedAction = (action) => {
		switch (action) {
			case "Due by":
				return "Due by";
			case "Upcoming":
				return "Due by";
			case "Complete":
				return "On";
			case "Missed":
				return "On";
			case "Nurse Only":
				return "Last updated";
			default:
				return "";
		}
	};

	const bgColourClass = CodesToColorMapFunc(code ?? "other", theme)?.bg();

	const getActionLabel = (action) => {
		switch (action) {
			case "Due by":
				return actionLabel ? (
					<>
						<div className="ss-clock text-stroke-thin text-sm pt-1"></div>
						<div className={"text-black text-sm font-light pl-2"}>
							{actionLabel}
						</div>
					</>
				) : null;
			case "Upcoming":
				return (
					<>
						<div className="ss-clock text-stroke-thin text-sm pt-1"></div>
						<div className={"text-black text-sm font-light pl-2"}>Upcoming</div>
					</>
				);
			case "Complete":
				return (
					<>
						<div className="ss-icon text-stroke-thin text-sm pt-1">
							&#x2713;
						</div>
						<div className={"text-black text-sm font-light pl-2"}>
							Completed
						</div>
					</>
				);
			case "Missed":
				return (
					<>
						<div className="ss-icon text-stroke-thin text-sm pt-1">
							&#x1F3AF;
						</div>
						<div className={"text-black text-sm font-light pl-2"}>Missed</div>
					</>
				);
			case "Nurse Only":
				return (
					<>
						<div className="ss-icon text-stroke-thin text-sm pt-1">
							<SlUser style={{ top: "-3px", position: "relative" }} />
						</div>
						<div className={"text-black text-sm font-light pl-2"}>
							{responseHistoryExists ? "In progress" : "New registration"}
						</div>
					</>
				);
			case "Patient Registration":
				return (
					<>
						<div className="ss-clock text-stroke-thin text-sm pt-1"></div>
						<div className={"text-black text-sm font-light pl-2"}>takes 5m</div>
					</>
				);
			default:
				return null;
		}
	};

	return (
		<ConditionalLink
			condition={!locked}
			to={{
				pathname:
					numQuestionnaires <= 1 ? "/questionnaire" : "/multiquestionnaire",
				state: { id: id, code: code },
			}}
		>
			<div className={"w-full flex max-w-panel min-h-24 mx-auto"}>
				<div
					className={`shadow-sm rounded-sm mr-0.5 w-4 max-w-panel grid grid-cols-4 gap-x-2 p-2 my-1 xl:my-5 ${bgColourClass}`}
				></div>
				<div
					className={`shadow-sm w-full rounded-sm max-w-panel grid grid-cols-${
						locked && action !== "Due by" ? "6" : "7"
					} gap-x-2 my-1 xl:my-5 mx-auto ${
						action === "Complete" ? "bg-gray-200" : bgColourClass
					} bg-opacity-15`}
				>
					<div
						className={`col-span-6 ${
							locked ? " pr-2" : " pr-0"
						} text-white font-bold px-6 py-3 grid grid-cols-8`}
					>
						<div
							className={
								"col-span-6 w-full flex justify-start items-center text-black"
							}
						>
							{getIconForCode(code, "text-xl h-6 w-5 text-stroke-thin")}
							<div
								className={`text-black pl-2 font-normal ${
									(!locked || action === "Upcoming") && "font-bold"
								}`}
							>
								{title}
							</div>
						</div>
						<div
							className={
								"text-black col-span-8 sm:col-span-3 flex justify-start items-center pl-0.5 pt-1"
							}
						>
							{getActionLabel(action)}
						</div>
						{action === "Nurse Only"
							? isValid(lastSubmissionDate) && (
									<div
										className={
											"text-black col-span-8 sm:col-span-5 flex justify-start items-center pl-0.5 pt-1"
										}
									>
										<div className="ss-icon text-sm pt-1 text-stroke-thin">
											&#x1F514;
										</div>
										<div className={"text-black text-sm font-light pl-2"}>
											{formattedAction(action)}{" "}
											{format(new Date(lastSubmissionDate), "EEE do LLL")}
										</div>
									</div>
							  )
							: isValid(dueDate) && (
									<div
										className={
											"text-black col-span-8 sm:col-span-5 flex justify-start items-center pl-0.5 pt-1"
										}
									>
										<div className="ss-icon text-sm pt-1 text-stroke-thin">
											&#x1F514;
										</div>
										<div className={"text-black text-sm font-light pl-2"}>
											{formattedAction(action)}{" "}
											{format(new Date(dueDate), "EEE do LLL")}
										</div>
									</div>
							  )}
					</div>
					{!locked && (
						<div
							className={`col-span-1 ${bgColourClass} rounded-sm font-bold text-base leading-tight`}
						>
							<div className="flex items-center justify-center h-full">
								<ArrowRight className={"w-4 text-black"} />
							</div>
						</div>
					)}
				</div>
			</div>
		</ConditionalLink>
	);
};
